export enum StepRegistarEnum {
  Step1 = 1,
  Step2 = 2,
  Step3 = 3,
}
